<template>
    <div>
        <div class="dashboard-view" >
             <div class="container-fluid fixed-top-bar-padding dashboard-wrapper">
                   <!-- <h2 class="d-inline-block" style="position: relative;"> -->
                        <div class="dashboard-view-header" style="z-index: 700;" >
                            <div class="media-call-icon">
                                <img :src="require(`@/csmworkflow/img/media-call.svg`)"/>
                                <span class="add-media-call-icon" >
                                    <img src="@/csmworkflow/img/add-icon.svg"/>
                                </span>
                            </div>
                            <div class="view-header-title">
                                <span class="listTitle" ><h2 style="font-weight:bold;">Media Call Dashboard</h2></span>
                                <span class="lastUpdate">Last Updated {{lastUpdatedDate  | moment("MMM D,YYYY HH:mm a")}}</span>
                                <span class="offLineMessage">{{isOnLine | offlineMessage}}</span>
                            </div>
                        </div>

                    <!-- </h2> -->

                <div class="dashboard-graphs" >
                        <div class="dashboard-header">
                                <div class="row">
                                    <div class=" stats-border breakpoint__fix">
                                        <div class="dashboard-stats">
                                            <div class="stats-left-name-wrap" >
                                                <span class="stats-left-name">Today</span>
                                            </div>
                                            <NumberStat statusData='today_progress' />
                                             <NumberStat statusData='today_pending' />
                                             <NumberStat statusData='today_waiting' />
                                        </div>
                                    </div>
                                </div>
                        </div>
                </div>
                <div class="dashboard-graphs" >
                        <div class="dashboard-header">
                                <div class="row">
                                    <div class=" stats-border breakpoint__fix">
                                        <div class="dashboard-stats">
                                            <div class="stats-left-name-wrap" >
                                                <span class="stats-left-name"> Closed</span>
                                            </div>
                                            <NumberStat statusData='closed_today' />
                                            <NumberStat statusData='closed_past7days' />
                                            <NumberStat statusData='closed_past31days' />
                                        </div>
                                    </div>
                                </div>
                        </div>
                </div>
                <div class="dashboard-graphs" >
                      <div class="dashboard-header">
                                 <GraphStat statusData='trending' />
                        </div>
                </div>
                 <div class="dashboard-graphs" >
                        <perfect-scrollbar >
                                 <GraphStat statusData='department' />
                        </perfect-scrollbar>
                </div>
            </div>
        </div>
        <div class="dashboard-right-list" >
             <div class="container-fluid">
                         <DeliverableList  :myWeek="false" :expandAll="expandAll" @lastUpdated='lastUpdated' />
            </div>
        </div>


    </div>



</template>
<script>
import DeliverableList from "../components/dashboard/DashboardMediaCallsList"; //List
import NumberStat from "../components/dashboard/NumberStat"; //NumberStat
import GraphStat from "../components/dashboard/GraphStat"; //NumberStat
import HeaderControls from "../components/common/HeaderControlsDashboardMediaCallsList";  //HeaderControls
import { mapGetters } from "vuex";

export default {
    data() {
    return {
      expandAll: !this.isMobile(),
      lastUpdatedDate: new Date(),
      isOnLine:navigator.onLine,
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers']),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  filters: {
        offlineMessage: function(isOnline){
            if(!isOnline){
                return "Internet connection is not available.";
            }
        }
    },
  components: {
    DeliverableList,
    HeaderControls,
    NumberStat,
    GraphStat
  },
  methods: {
    lastUpdated(lastUpdated) {
    this.lastUpdatedDate = lastUpdated;
    }
  },
    beforeDestroy() {
        window.removeEventListener('online', ()=>{this.isOnLine=true});
        window.removeEventListener('offline', ()=>{this.isOnLine=false});
    },
    async mounted() {
         window.addEventListener('online', ()=>{this.isOnLine=true});
         window.addEventListener('offline', ()=>{this.isOnLine=false});
    }
}
</script>
